<template>
    <div class="user">

        <div class="small-title">
            Rediger dine oplysninger
        </div>

        <form class="create-user" autocomplete="off">
            <input name="hidden" type="text" autocomplete="off" style="display:none;" />
            <div class="row">
                <div class="col-lg-6">
                    <div class="name">
                        <label>Navn *</label>
                        <input type="text" v-model="$auth.user().name" placeholder="Navn" />
                    </div>
                </div>
                <div class="col-lg-6">
                    <label>Brugerrolle</label>
                    <div style="height:40px;line-height:40px">
                        <span v-if="$auth.user().roles[0].name === 'super-admin'">Super Admin</span>
                        <span v-if="$auth.user().roles[0].name === 'admin'">Administrator</span>
                        <span v-if="$auth.user().roles[0].name === 'user'">Bruger</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="email">
                        <label>E-mail *</label>
                        <input type="email" name="iufbw379fb" v-model="$auth.user().email" placeholder="E-mail" />
                    </div>  
                </div>
                <div class="col-lg-6">
                    <div class="password">
                        <label>Ny adgangskode *</label>
                        <input type="password" autocomplete="new-password" v-model="user.new_password" placeholder="Ny adgangskode" />
                        <div class="small">Min. 8 karakterer (udfyldes kun hvis du vil skifte adgangskode)</div>
                    </div>  
                </div>
            </div>
            <br>
            <div class="action" align="right">
                <div class="pretty-button" @click="updateUser()">
                    Opdater
                </div>
            </div>
        </form>

    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .user {

        .small-title {
            font-size: $fontsize--medium;
            margin-bottom: $margin--small;
        }

        .create-user {
            background: $color--white;
            padding: $padding--main;
            border-radius: $borderradius--main;
            box-shadow: $boxshadow--creative;

            .small {
                font-size: $fontsize--small;
                margin-top: 4px;
            }

            label {
                font-weight: 600;
                margin-bottom: 5px;
                display: block;
            }

            input, select {
                height: 40px;
                padding: 4px 10px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-sizing: border-box;
                border-radius: $borderradius--main;
                cursor: pointer;
                width: 100%;
                // margin-bottom: $margin--small;
            }
        }

        .list {

            .user {
                padding: $padding--main;
                background: $color--white;
                border-radius: $borderradius--main;
                box-shadow: $boxshadow--creative;
                margin-bottom: -$margin--main;

                input, select {
                    height: 40px;
                    padding: 4px 10px;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    box-sizing: border-box;
                    border-radius: $borderradius--main;
                    cursor: pointer;
                    width: 100%;
                    margin-bottom: $margin--small;
                }

                .name {
                    flex: 0 0 30%;
                    font-weight: 600;

                    .role {
                        font-weight: normal;
                        font-size: $fontsize--sm;
                    }
                }

                .email {
                    flex: 0 0 30%;
                }

                .password {
                    flex: 0 0 25%;
                }

                .actions {
                    flex: 0 0 15%;
                    display: flex;
                    justify-content: space-between;

                    .action {
                        cursor: pointer;
                    }
                }

                &:not(:last-of-type) {
                    margin-bottom: $margin--small;
                }
            }
        }
    }

</style>

<script>
import * as userService from '@/services/userService'

export default {
    data () {
        return {
            user: {
                new_password: ''
            }
        }
    },
    methods: {
        updateUser (user) {
            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.')
                return
            }
            let body = {
                name: this.$auth.user().name,
                email: this.$auth.user().email
            }
            if (this.user.new_password !== '') {
                body.password = this.user.new_password
                body.password_confirmation = this.user.new_password
            }
            userService.update(this.$auth.user().uuid, body, (response) => {
                this.$toastr('success', 'Profil opdateret. Opdaterer siden.', 'Sådan!')
                setTimeout(() => {
                    window.location.href = '/'
                }, 1000)
            }, (err) => {
                console.log(err)
                this.$toastr('error', 'Der skete en fejl ved opdatering af brugeren', 'Hovsa!')
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// user.vue?cb9b4174